const mutations = {


    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
        state.isVerticalNavMenuActive = value
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
        state.mainLayoutType = val
    },
    UPDATE_NAVBAR_TYPE(state, val) {
        console.log('updatting navbar: ' + val);
        state.navbarType = val
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
        state.verticalNavMenuItemsMin = val
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
        state.verticalNavMenuWidth = width
    },


    // VxAutoSuggest

    UPDATE_STARRED_PAGE(state, payload) {

        // find item index in search list state
        const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url === payload.url)

        // update the main list
        state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.url === payload.url)

            // remove item using index
            state.starredPages.splice(index, 1)
        }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10)
        state.starredPages = list.concat(starredPagesMore)
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false
        const lastItemInStarredLimited = state.starredPages[10]
        const starredPagesLimited = state.starredPages.slice(0, 10)
        state.starredPages = starredPagesLimited.concat(list)

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true
        })

        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited)
        }
    },


    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
    UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
    UPDATE_THEME(state, val) { state.theme = val },
    UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
    UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    // Updates user info in state and localstorage
    UPDATE_USER_INFO(state, payload) {

        // Get Data localStorage
        const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

        for (const property of Object.keys(payload)) {

            if (payload[property] !== null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppActiveUser[property] = payload[property]

                // Update key in localStorage
                userInfo[property] = payload[property]
            }


        }
        // Store data in localStorage
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_AUTH_TOKEN(state, token) {
        state.AuthToken = token;
    },
    // Updates user info in state and localstorage
    UPDATE_EVOLUGYUSER_INFO(state, payload) {

        // Get Data localStorage
        const userInfo = JSON.parse(sessionStorage.getItem('evolugyUser')) || state.AppActiveUser

        for (const property of Object.keys(payload)) {

            if (payload[property] !== null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppActiveUser[property] = payload[property]

                // Update key in localStorage
                userInfo[property] = payload[property]
            }


        }
        // Store data in localStorage
        sessionStorage.setItem('evolugyUser', JSON.stringify(userInfo))
    },
    // --------------
    // EVENTS -------
    // --------------
    SET_EVENTS(state, events) {
        state.events = events
    },
    SET_SCHEDULE(state, schedule) {
        state.schedule = schedule
    },
    // clinic EVENTS - availability
    SET_CLINICABD(state, clinicAvailabilityByDate) {
        state.clinicAvailabilityByDate = clinicAvailabilityByDate
    },
    // --------------
    // CONSULTATIONs -------
    // --------------
    SET_CONSULTATIONS(state, consultations) {
        state.consultations = consultations
    },
    SET_NUM_CONSULTATIONS(state, consultations_qty) {
        state.consultations_qty = consultations_qty
    },
    SET_NUM_PENDING_CONSULTATIONS(state, consultations_qty) {
        state.pending_consultations_qty = consultations_qty
    },
    SET_NUM_CONFIRMED_CONSULTATIONS(state, consultations_qty) {
        state.confirmed_consultations_qty = consultations_qty
    },
    SET_NUM_CANCELED_CONSULTATIONS(state, consultations_qty) {
        state.canceled_consultations_qty = consultations_qty
    },
    SET_PAID_CONSULTATIONS(state, paidConsultations) {
        state.paidConstultations = paidConsultations;
    },
    SET_ACTIVE_CONSULTATION(state, consultation) {
        state.activeConsultationInfo = consultation
    },
    SET_PUBLIC_CONSULTATION(state, consultation) {
        state.publicConsultationInfo = consultation
    },
    // --------------
    // CLINICS
    // --------------
    SET_CLINICS(state, clinics) {
        state.clinics = clinics
    },
    SET_CLINICS_PUBLIC(state, clinics) {
        state.clinicsPublic = clinics
    },
    // -----------------
    //  USER MANAGEMENT
    // -----------------
    SET_USERS(state, users) {
        state.users = users
    },
    SET_PATIENTS(state, patients) {
        state.patients = patients
    },
    SET_SECRETARIES(state, secretaries) {
        state.secretaries = secretaries
    },
    SET_ACTIVE_PATIENTS_COUNT(state, active_patients_qty) {
        state.active_patients_qty = active_patients_qty
    },
    SET_CURRENT_PATIENT(state, patients) {
        state.currentPatient = patients
    },
    SET_PUBLIC_PATIENT(state, patient) {
        state.publicPatient = patient
    },
    SET_PUBLIC_DOCTOR(state, doctor) {
        state.publicDoctor = doctor
    },
    // SECRETARY DOCTOR
    SET_ACTIVE_DOCTOR_ID(state, id) {
        return new Promise((resolve, reject) => {
            state.activeDoctorID = id

            resolve(true);

        });
    },
    SET_ACTIVE_DOCTOR(state, userData) {
        state.activeDoctor = userData
    },
    // --------------
    // MEDICATIONS --
    // --------------
    SET_MEDICATIONS(state, medications) {
        state.medications = medications
    },
    // --------------
    // PRESCRIPTIONS 
    // --------------
    SET_ACTIVE_PRESCRIPTION(state, prescription) {
        state.activePrescriptionInfo = prescription
    },
    SET_PRESCRIPTIONS_LIST(state, prescriptions) {
        state.prescriptionsList = prescriptions
    },
    // --------------
    // EXAMS -------
    // --------------
    SET_ACTIVE_EXAM(state, exam) {
        state.activeExamInfo = exam
    },
    SET_EXAMS_LIST(state, exams) {
        state.examsList = exams
    },
    // ----------------------------
    // NOTIFICATIONS --------------
    // ----------------------------
    SET_NOTIFS_LIST(state, notifs) {
        state.notifsList = notifs
    },
}

export default mutations